<template>
  <div class="simple-table-card">
    <!-- HEADER -->
    <div class="table-header">
      <h5 class="mb-0">{{ title }}</h5>
      <div class="ml-auto">
        <b-btn
          v-if="showAdd"
          variant="warning"
          size="sm"
          @click="$emit('onAdd')"
        >
          <i class="ri-add-line"></i> Tambah Data
        </b-btn>
      </div>
    </div>

    <!-- TABLE -->
    <b-table
      :fields="computedFields"
      :items="data"
      :per-page="pagination.perPage"
      :current-page="pagination.currentPage"
      responsive
      class="custom-table"
      head-variant="light"
      borderless
    >
      <!-- Actions -->
      <template #cell(actions)="{ item, index }">
        <div class="d-flex">
          <b-btn
            v-if="expand"
            size="sm"
            variant="outline-secondary"
            class="action-btn"
            @click="toggleRow(index)"
          >
            <i :class="expanded[index] ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
          </b-btn>
          <b-btn
            v-if="showEdit"
            size="sm"
            variant="outline-info"
            class="action-btn edit-btn"
            @click="$emit('onEdit', item)"
          >
            <i class="ri-pencil-line"></i>
          </b-btn>
          <b-btn
            v-if="showDelete"
            size="sm"
            variant="outline-danger"
            class="action-btn delete-btn"
            @click="$emit('onDelete', item, index)"
          >
            <i class="ri-delete-bin-line"></i>
          </b-btn>
        </div>
      </template>

      <!-- No column -->
      <template #cell(index)="{ index }">
        {{ index + (pagination.currentPage - 1) * pagination.perPage + 1 }}.
      </template>

      <!-- Row details -->
      <template v-if="expand" #row-details="{ item, index }">
        <div v-if="expanded[index]">
          <slot name="row-details" :row="item"></slot>
        </div>
      </template>
    </b-table>

    <!-- PAGINATION -->
    <div v-if="!hidePagination" class="pagination-wrapper">
      <b-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total-rows="pagination.totalRows"
        align="center"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleTable",

  props: {
    title: { type: String, default: "" },
    data: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
      }),
    },
    showAdd: { type: Boolean, default: true },
    showEdit: { type: Boolean, default: true },
    showDelete: { type: Boolean, default: true },
    hidePagination: { type: Boolean, default: true },
    expand: { type: Boolean, default: false },
  },

  data() {
    return {
      expanded: {},
    };
  },

  computed: {
    computedFields() {
      let f = [...this.fields];
      f.unshift({ key: "index", label: "No" });
      f.unshift({ key: "actions", label: "" });
      return f;
    },
  },

  methods: {
    toggleRow(index) {
      this.$set(this.expanded, index, !this.expanded[index]);
      console.log("Expand: ", this.expanded[index]);
    },
  }
};
</script>

<style scoped>
.simple-table-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  overflow: hidden;
}

.table-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.table-header h5 {
  font-weight: 600;
  color: #333;
}

.custom-table thead th {
  font-weight: 600;
  font-size: 14px;
  color: #555;
  border: none !important;
}

.custom-table td {
  font-size: 14px;
  color: #444;
  vertical-align: middle;
  border-top: 1px solid #f5f5f5 !important;
}

.custom-table tr:first-child td {
  border-top: none !important;
}

.action-btn {
  border-radius: 8px;
  margin-right: 6px;
  padding: 4px 8px;
}

.edit-btn {
  background-color: #e6f7f9;
  color: #0a6c75;
  border: none;
}

.delete-btn {
  background-color: #fdeaea;
  color: #c53030;
  border: none;
}

.pagination-wrapper {
  padding: 10px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/base/component/simple-table.vue